import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { SETTINGS } from '../../core/config/common.settings';
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  activeTabIndex = 0;
  index: any;
  tabRef: any;
  constructor(private route: ActivatedRoute, private router: Router) {

  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.tabRef = params.get("tab");
    });
  }

  test(data:any):void{
    this.router.navigate([`/${data}`]);
  }

  logRoute(target: string) {
    const fullUrl = this.router.createUrlTree([target], { relativeTo: this.route }).toString();
  }

  protected readonly SETTINGS = SETTINGS;
}
